import {
  getDownloadURL,
  getStorage,
  ref as storageRef,
} from 'firebase/storage'
import logger from '@/utils/logger'
import type { DSImage, DSImage3rdParty } from '@/types'

async function guessResizedUrl(id: string, imageName: string, size = '300x450'): Promise<string> {
  const storage = getStorage()
  try {
    const resizedImageName = imageName.replace(
      // eslint-disable-next-line regexp/no-super-linear-backtracking
      /(images\/)(.*)\.(.*$)/,
      (match, g1, g2) => {
        return `${g1 + g2.replace(id, `${id}/resized`)}_${size}.webp`
      },
    )
    const resizedImageRef = storageRef(storage, resizedImageName)
    return getDownloadURL(resizedImageRef)
  } catch (error) {
    logger(error)
    const originalImageRef = storageRef(storage, imageName)
    return getDownloadURL(originalImageRef)
  }
}

export function getPlaceholderImageUrl(id: string): string {
  id = id.replace(/users\//g, '')
  return `https://picsum.photos/seed/${id}/600/600`
}

export default async function (
  imageObject: DSImage | DSImage3rdParty | null,
  folderId: string,
  fallbackImage = '',
): Promise<string> {
  let resizedImage = null
  try {
    if (!imageObject)
      throw new Error('no image')
    if ((imageObject as DSImage3rdParty)['3rdParty']) {
      const imageObject3rdParty = imageObject as DSImage3rdParty
      resizedImage = imageObject3rdParty.thumbnailUrl ?? imageObject3rdParty.rawUrl
    } else {
      const usedDefaultAvatar
        = (imageObject.filepath?.indexOf('common/avatars') ?? -1) === -1

      resizedImage = await guessResizedUrl(
        usedDefaultAvatar ? 'common/avatars' : folderId,
        imageObject.filepath,
        imageObject.resize,
      )
    }
  } catch (error: unknown) {
    logger(error)
    resizedImage
      = fallbackImage
      || getPlaceholderImageUrl(folderId)
  }

  return resizedImage
}
